import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import Panel from '../../../../components/structure/Panel'
import Markdown from '../../../../components/presentation/Markdown'
import { COLORS } from '@btime/constants'

const ObservationsPanel = ({ serviceOrder }) => {
  const { t } = useTranslation('serviceOrders')
  if (!serviceOrder.description) return false

  return (
    <Panel lineBorder mediumPadding>
      <Title size="h6">{t('fields.notes')}</Title>
      <Markdown value={serviceOrder.description} color={COLORS.dark2} fontFamily="system-ui" />
    </Panel>
  )
}

export default ObservationsPanel
